import { render } from "./surfaceHotspot.vue?vue&type=template&id=ce87acf6"
import script from "./surfaceHotspot.vue?vue&type=script&lang=js"
export * from "./surfaceHotspot.vue?vue&type=script&lang=js"

import "./surfaceHotspot.vue?vue&type=style&index=0&id=ce87acf6&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\au-csmv-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__